import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ResponseResult, State } from '../core/state';
import { EnhancedQuestion } from '../core/question';

@Injectable()
export class QuestionService {
    private readonly url = `${environment.apiUrl}/company/questions`;
    private jsonContentHeader: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) { }

    get(limit: number, offset: number): Observable<ResponseResult<EnhancedQuestion[]>> {
        limit = limit > 0 ? limit : 50;
        offset = offset > 0 ? offset : 0;

        return this.http
            .get(`${this.url}?limit=${limit}&offset=${offset}`, { headers: this.jsonContentHeader })
            .map(result => {
                const response: ResponseResult<EnhancedQuestion[]> = new ResponseResult<EnhancedQuestion[]>();
                if (result['options']) {
                    response.state = result['options'] as State;
                }
                if (result['data']) {
                    response.data = result['data'].map(q => this.wrapQuestion(q));
                }

                return response;
            }, error => this.handleError(error));
    }

    publish(newQuestionString): Observable<EnhancedQuestion> {
        return this.http
            .post(this.url, newQuestionString, { headers: this.jsonContentHeader })
            .map(result => this.wrapQuestion(result['data']));
    }

    update(id, updatedQuestionString): Observable<EnhancedQuestion> {
        return this.http
            .put(`${this.url}/${id}`, updatedQuestionString, { headers: this.jsonContentHeader })
            .map(result => this.wrapQuestion(result['data']));
    }

    remove(id): Observable<boolean> {
        return this.http
            .delete(`${this.url}/${id}`)
            .map(result => {
                return true;
            });
    }

    private wrapQuestion(raw: any): EnhancedQuestion {
        const question = new EnhancedQuestion();
        question.id = raw.id;
        question.created = raw.created;
        question.title = raw.question;
        question.answers = raw.answers;
        question.truncateQuestion();
        question.truncateAnswer();

        return question;
    }

    private handleError(error: HttpErrorResponse): Promise<any> {
        const message = this.resolveError(error);
        if (message) {
            return Promise.reject(message);
        }

        return Promise.reject(error);
    }
    private resolveError(res: HttpErrorResponse): any {
        if (res.error && res.error.errors && res.error.errors.length > 0) {
            const parts = res.error.errors[0].split('.');
            if (parts.length <= 0) {
                return null;
            }

            let result = this;
            for (const part of parts) {
                result = result[part];
                if (!result) {
                    break;
                }
            }

            return result;
        }
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/providers/question.service.ts